import { Check } from "lucide-react";
import type { Sector } from "@/types/risk-analysis";
import { cn } from "@/lib/utils";
import { getSectorIcon } from "./sectorIcons";

type SectorCardProps = {
  sector: Sector;
  isSelected: boolean;
  onToggle: (sectorName: string) => void;
};

export default function SectorCard({
  sector,
  isSelected,
  onToggle,
}: SectorCardProps) {
  const Icon = getSectorIcon(sector.cod);

  return (
    <button
      type="button"
      onClick={() => onToggle(sector.nume)}
      className={cn(
        "relative flex items-start gap-2.5 rounded-lg border p-3 text-left transition-all duration-150 cursor-pointer",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-400 focus-visible:ring-offset-1",
        isSelected
          ? "border-blue-400 bg-blue-50 ring-1 ring-blue-400"
          : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"
      )}
    >
      <div
        className={cn(
          "mt-0.5 shrink-0 rounded-md p-1.5 transition-colors duration-150",
          isSelected
            ? "bg-blue-100 text-blue-600"
            : "bg-slate-100 text-slate-400"
        )}
      >
        <Icon className="h-4 w-4" />
      </div>

      <div className="min-w-0 flex-1">
        <span
          className={cn(
            "block text-sm font-medium leading-tight transition-colors duration-150",
            isSelected ? "text-blue-900" : "text-slate-700"
          )}
        >
          {sector.nume}
        </span>
        <span className="mt-0.5 block text-[11px] leading-tight text-slate-400 line-clamp-1">
          {sector.subsectoare}
        </span>
      </div>

      <div
        className={cn(
          "absolute right-2 top-2 flex h-4 w-4 items-center justify-center rounded-full transition-all duration-150",
          isSelected
            ? "bg-blue-500 text-white scale-100 opacity-100"
            : "bg-slate-200 scale-75 opacity-0"
        )}
      >
        <Check className="h-2.5 w-2.5" strokeWidth={3} />
      </div>
    </button>
  );
}
